module.exports = __webpack_public_path__ + "media/application/images/ui/menu-table-active-fc8c3032361c5d33ff5295f36907cd3d.svg";